module.exports = __webpack_public_path__ + "static/img/empty.f8104c7.svg";